import goalManagementService from '../services/goalManagementService';
import { ServerAlertAction } from '../../common'
import { GoalDescriptionBody } from '../types/GoalDescriptionBody';
import { GoalManagementAction } from '../types/GoalManagementAction';
import {
    MasterClass,
    MasterChapter,
    MasterConcept,
    MasterSubSubject,
    MasterSubject
} from '../types/GoalManagementMasterBody'
import CourseSyllabusBody from '../types/CourseSyllabusBody'

const getGoalList = () => (dispatch: any) => {
    const success = (data: GoalDescriptionBody[]): GoalManagementAction => ({
        type: 'GOAL_MANAGEMENT_LIST_SUCCESS', data
    });

    goalManagementService.list()
        .then((res: any) => dispatch(success(res)))
}
const getNewGoalList = () => (dispatch: any) => {
    const success = (data: GoalDescriptionBody[]): GoalManagementAction => ({
        type: 'GOAL_MANAGEMENT_NEWLIST_SUCCESS', data
    });

    goalManagementService.goalList("")
        .then((res: any) => dispatch(success(res)))
}

const getMaster = (getBy: string, id: string, classId: string = "", courseId?:string) => (dispatch: any) => {

    switch (getBy) {
        case 'class':
            const masterClass = (data: MasterClass[]): GoalManagementAction => ({
                type: 'GOAL_MANAGEMENT_MASTER_CLASS', data
            });
            goalManagementService.fetchMasterClass()
                .then((res: any) => dispatch(masterClass(res)))
            break;
        case 'subject':
            const masterSubject = (data: MasterSubject[]): GoalManagementAction => ({
                type: 'GOAL_MANAGEMENT_MASTER_SUBJECTS', data
            });
            dispatch(masterSubject([]))
            goalManagementService.fetchMasterCountSubject(classId, courseId)
                .then((res: any) => dispatch(masterSubject(res)))
            break;
        case 'subSubject':
            const masterSubSubject = (data: MasterSubSubject[]): GoalManagementAction => ({
                type: 'GOAL_MANAGEMENT_MASTER_SUBSUBJECTS', data
            });
            dispatch(masterSubSubject([]))
            goalManagementService.fetchMasterSubSubject(id, classId, courseId)
                .then((res: any) => dispatch(masterSubSubject(res)))
            break;
        case 'chapter':
            const masterChapter = (data: MasterChapter[]): GoalManagementAction => ({
                type: 'GOAL_MANAGEMENT_MASTER_CHAPTERS', data
            });
            dispatch(masterChapter([]))
            goalManagementService.fetchMasterChapter(id, classId, courseId)
                .then((res: any) => dispatch(masterChapter(res)))
            break;
        case 'concept':
            const masterConcept = (data: MasterConcept[]): GoalManagementAction => ({
                type: 'GOAL_MANAGEMENT_MASTER_CONCEPTS', data
            });
            dispatch(masterConcept([]))
            goalManagementService.fetchMasterConcept(id, classId, courseId)
                .then((res: any) => dispatch(masterConcept(res)))
            break;


        default:
            break;
    }
}


const showMsg = (msg: string, vari: any) => {
    let showAlert = (message: string, variant: 'error' | 'success' = 'error'): ServerAlertAction => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbar: true }
    })
    return (dispatch: any) => {
        dispatch(showAlert(msg, vari));
    }
}


const getCourseData = (courseId: string) => (dispatch: any) => {
    const success = (data: CourseSyllabusBody[]): GoalManagementAction => ({
        type: 'GOAL_MANAGEMENT_COURSE_DATA', data
    });

    goalManagementService.getCourseData(courseId)
        .then((res: any) => dispatch(success(res)))
}

const updateCourseData = (courseData: CourseSyllabusBody) => (dispatch: any) => {
    const success = (data: CourseSyllabusBody): GoalManagementAction => ({
        type: 'GOAL_MANAGEMENT_COURSE_DATA_UPDATE', data
    });
    dispatch(success(courseData))
}

const setShowAddContent = (value: boolean) => (dispatch: any) => {
    const success = (value: boolean): GoalManagementAction => ({
        type: 'GOAL_MANAGEMENT_SHOW_ADD_CONTENT', data: value
    });
    dispatch(success(value))
}
 const updateCurrentPage = (payload: number) => {
    return {
        type: "UPDATE_CURRENT_PAGE", 
        payload: payload
    }
}
 const nextPage = (payload: any) => {
    console.log(payload)
    return {
        type: "NEXT_PAGE",
        payload: payload
    }
}
 const previousPage = (payload: any) => {
    return {
        type: "PREVIOUS_PAGE",
        payload: payload
    }
}
 const firstPage = (payload:any ) => {
    return {
        type: "FIRST_PAGE",
        payload: payload
    }
}
 const lastPage = (payload:any) => {
    return {
        type: "LAST_PAGE",
        payload: payload
    }
}

export {
    getGoalList,
    getNewGoalList,
    showMsg,
    getMaster,
    getCourseData,
    updateCourseData,
    setShowAddContent,
    updateCurrentPage,
    nextPage,
    previousPage,
    firstPage,
    lastPage
};